import { createRouter, createWebHistory } from 'vue-router'
import { authAPI } from '@/services/api'
import { useEventsStore } from '@/stores/events'
import ComboView from '../views/ComboView.vue'
import EventView from '../views/EventView.vue'
import HomeView from '../views/HomeView.vue'
import MyBetsView from '../views/MyBetsView.vue'
import ListView from '../views/ListView.vue'
import StandingsView from '../views/StandingsView.vue'
import { setPageTitle } from '@/services/utils'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView,
    },
    {
      path: '/standings',
      name: 'standings',
      component: StandingsView,
    },
    {
      path: '/standings/:type/:timeframe?',
      name: 'standings-type',
      component: StandingsView,
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('../views/TestView.vue'),
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/AboutView.vue'),
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('../views/PrivacyView.vue'),
    },
    {
      path: '/info',
      name: 'info',
      component: () => import('../views/InfoView.vue'),
    },
    {
      path: '/list',
      name: 'list',
      component: ListView,
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/LoginView.vue'),
      meta: { requiresGuest: true } // Only accessible when not logged in
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import('../views/ResetPasswordView.vue'),
      meta: { requiresGuest: true }
    },
    {
      path: '/password/reset/:token',
      name: 'reset-password-confirm',
      component: () => import('../views/ResetPasswordConfirmView.vue'),
      meta: { requiresGuest: true }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('../views/RegisterView.vue'),
      meta: { requiresGuest: true } // Only accessible when not logged in
    },
    {
      path: '/mybets',
      name: 'mybets',
      component: MyBetsView,
      meta: { requiresAuth: true } // Only accessible when logged in
    },
    {
      path: '/mybets/:id',
      name: 'mybet',
      component: () => import('../views/MyBetView.vue'),
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('../views/ProfileView.vue'),
      meta: { requiresAuth: true } // Only accessible when logged in
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('../views/SettingsView.vue'),
      meta: { requiresAuth: true } // Only accessible when logged in
    },
    {
      path: '/event/:id',
      name: 'event',
      component: EventView,
    },
    {
      path: '/combo',
      name: 'combo',
      component: ComboView,
    },
    // Catch-all route for 404 Page Not Found
    {
      path: '/:pathMatch(.*)*',
      name: 'notfound',
      component: () => import('../views/PageNotFound.vue'),
    },
  ],
})

// Navigation guard
router.beforeEach((to, from, next) => {
  // Reset pagination for events list when navigating away from list-related pages
  try {
    const eventsStore = useEventsStore()
    const preserveRoutes = ['list', 'event', 'mybet', 'combo']
    if (!to.name || !preserveRoutes.includes(String(to.name))) {
      // reset to first page when navigating to unrelated routes
      eventsStore.pagination.current_page = 1
      // reset filters as well
      if (typeof eventsStore.clearFilters === 'function') {
        eventsStore.clearFilters()
      }
    }
  } catch (e) {
    // In case Pinia isn't initialized yet or store access fails, ignore.
    // This avoids router errors during app bootstrap.
    // console.warn('Could not access eventsStore in router guard', e)
  }
  const isAuthenticated = authAPI.isAuthenticated()
  
  // Routes that require the user to be a guest (not logged in)
  if (to.meta.requiresGuest && isAuthenticated) {
    next({ name: 'home' })
    return
  }
  
  // Routes that require authentication
  if (to.meta.requiresAuth && !isAuthenticated) {
    next({ name: 'login' })
    return
  }
  
  next()
})


// Aggiorna il titolo della pagina ad ogni navigazione
router.afterEach((to) => {
  // const { t, te } = useI18n()

  // // Candidates: current route name, then immediate parent route name
  // const candidates = []
  // if (to.name) candidates.push(String(to.name))
  // const matched = to.matched || []
  // if (matched.length > 1) {
  //   const parent = matched[matched.length - 2]
  //   if (parent && parent.name) candidates.push(String(parent.name))
  // }

  // let translated = null
  // for (const routeName of candidates) {
  //   const key = `page_title.${routeName.replace(/-/g, '_')}`
  //   if (te(key)) {
  //     translated = t(key)
  //     break
  //   }
  // }

  // setPageTitle(translated)

  setPageTitle(null)
})

export default router
